<template>
  <section id="footer" data-speed="4" data-type="background">
    <div class="container">
      <div class="row">
        <clearfix :wide="true" :bootstrap="true"></clearfix>

        <footer-copyleft></footer-copyleft>
        <footer-contact></footer-contact>

        <clearfix :wide="true" :bootstrap="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
import Clearfix from '@/components/utils/Clearfix'
import FooterCopyleft from '@/components/partials/FooterCopyleft'
import FooterContact from '@/components/partials/FooterContact'
export default {
  components: {
    Clearfix,
    FooterCopyleft,
    FooterContact
  }
}
</script>

<style>
#footer {
  background: url('../../assets/img/bg/about.png') 50% 0 fixed;
  height: auto;
  margin: 0 auto;
  width: 100%;
  position: relative;
  padding: 100px 0;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// Footer.vue?4dea03f1